// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {IconName} from '@wandb/weave/components/Icon';
import copyToClipboard from 'copy-to-clipboard';
import _, {isNil} from 'lodash';
import React, {useState} from 'react';

import {displayValue} from '../../../util/runhelpers';
import type {TreeItem} from '../types';
import {
  DEFAULT_COLUMN_WIDTH,
  DEFAULT_ROW_HEIGHT,
  getNumLinesFromPixelRowHeight,
} from './CellDimensionsSelector';

export type CellTitleProps = {
  item: TreeItem | null | undefined;
  columnWidth?: number;
  rowHeight?: number;
};

export const CellTitleNew = ({
  item,
  columnWidth = DEFAULT_COLUMN_WIDTH,
  rowHeight = DEFAULT_ROW_HEIGHT,
}: CellTitleProps) => {
  let title = '';
  if (
    !isNil(item) &&
    typeof item === 'object' &&
    (item as any)._type === 'histogram'
  ) {
    const bins = (item as any).bins;
    title = `histogram (${displayValue(bins[0])} to ${displayValue(
      bins[bins.length - 1]
    )})`;
  }

  title = JSON.stringify(item);

  const [isHover, setIsHover] = useState(false);
  const [icon, setIcon] = useState<IconName>('copy');
  const canCopy = !isNil(item) && isHover && columnWidth && rowHeight;

  return (
    <div
      className="relative flex flex-shrink-0 flex-grow basis-0 items-center justify-between"
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{height: rowHeight, width: columnWidth}}>
      <div
        className="cell-new overflow-hidden text-ellipsis break-all"
        style={{
          width: columnWidth, // make room for the button on hover
          height: rowHeight,
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: getNumLinesFromPixelRowHeight(rowHeight), // make the ellipsis appear on the bottom line
        }}
        title={title}>
        {!isNil(item) ? displayValue(item) : '-'}
      </div>
      {canCopy && (
        <div
          // use absolute spacing so that it'll appear on top of the text on the right side
          // and not make the text jump around when you're hovering.
          // color matches @lightSky which is the legacy color used for a hovered row
          className="absolute right-0 top-4 mr-4 bg-[#f3fafd]">
          <Button
            icon={icon}
            variant="ghost"
            size="small"
            onClick={() => {
              copyToClipboard(_.isString(item) ? item : title);
              setIcon('checkmark-circle'); // some feedback to the user that the text was copied
              setTimeout(() => setIcon('copy'), 2000);
            }}
          />
        </div>
      )}
    </div>
  );
};
